module.exports = __webpack_public_path__ + "static/media/ō_64k.f2afc81b.mp3";